// import React from 'react';
// import Navbar from '../components/Navbar';
// import HlcFooter from '../components/HlcFooter';

// const ResidentialPage = () => {
//   return (
//     <>
//     <Navbar />
//       {/* ================= RESIDENTIAL SPACES – CORE ================= */}
//       <section style={{marginTop:30}} className="hlc-res-spaces">
//         <div className="hlc-res-spaces__inner">
//           {/* Section Head */}
//           <header className="hlc-res-spaces__head">
//             <h2>Lighting for Every Residential Space</h2>
//             <p>
//               Thoughtfully designed lighting solutions tailored for different areas of your home —
//               combining comfort, efficiency and modern aesthetics.
//             </p>
//           </header>

//           {/* Spaces Grid */}
//           <div className="hlc-res-spaces__grid">
//             {/* Living Room */}
//             <div className="space-card">
//               <img 
//                 decoding="async" 
//                 src="https://skyblue-mink-835304.hostingersite.com/wp-content/uploads/2025/12/Residential-Living-Room.png" 
//                 alt="Living Room Lighting"
//               />
//               <div className="space-body">
//                 <h3>Living Rooms</h3>
//                 <p>
//                   Warm, ambient lighting for relaxation, gatherings and everyday comfort.
//                 </p>
//                 <ul>
//                   <li>Soft &amp; glare-free illumination</li>
//                   <li>Decorative bulbs &amp; ceiling lights</li>
//                   <li>Energy-efficient LEDs</li>
//                 </ul>
//                 <a 
//                   href="https://skyblue-mink-835304.hostingersite.com/led-bulbs/" 
//                   className="space-cta"
//                 >
//                   Explore Living Room Lighting →
//                 </a>
//               </div>
//             </div>

//             {/* Bedrooms */}
//             <div className="space-card">
//               <img 
//                 decoding="async" 
//                 src="https://skyblue-mink-835304.hostingersite.com/wp-content/uploads/2025/12/Residential-Bedroom.png" 
//                 alt="Bedroom Lighting"
//               />
//               <div className="space-body">
//                 <h3>Bedrooms</h3>
//                 <p>
//                   Comfortable and soothing lighting designed for rest and personal spaces.
//                 </p>
//                 <ul>
//                   <li>Low-glare &amp; warm light tones</li>
//                   <li>Bedside &amp; accent lighting</li>
//                   <li>Long-life LED solutions</li>
//                 </ul>
//                 <a 
//                   href="https://skyblue-mink-835304.hostingersite.com/led-bulbs/" 
//                   className="space-cta"
//                 >
//                   Explore Bedroom Lighting →
//                 </a>
//               </div>
//             </div>

//             {/* Kitchens */}
//             <div className="space-card">
//               <img 
//                 decoding="async" 
//                 src="https://skyblue-mink-835304.hostingersite.com/wp-content/uploads/2025/12/Residential-Kitchen.png" 
//                 alt="Kitchen Lighting"
//               />
//               <div className="space-body">
//                 <h3>Kitchens</h3>
//                 <p>
//                   Bright and focused lighting to support cooking, cleaning and productivity.
//                 </p>
//                 <ul>
//                   <li>Uniform task lighting</li>
//                   <li>Under-cabinet LEDs</li>
//                   <li>High efficiency &amp; durability</li>
//                 </ul>
//                 <a 
//                   href="https://skyblue-mink-835304.hostingersite.com/led-bulbs/" 
//                   className="space-cta"
//                 >
//                   Explore Kitchen Lighting →
//                 </a>
//               </div>
//             </div>

//             {/* Outdoor / Balconies */}
//             <div className="space-card">
//               <img 
//                 decoding="async" 
//                 src="https://skyblue-mink-835304.hostingersite.com/wp-content/uploads/2025/12/Residential-Outdoor.png" 
//                 alt="Outdoor Home Lighting"
//               />
//               <div className="space-body">
//                 <h3>Outdoor &amp; Balconies</h3>
//                 <p>
//                   Weather-resistant lighting to enhance safety and outdoor aesthetics.
//                 </p>
//                 <ul>
//                   <li>IP-rated outdoor lights</li>
//                   <li>Pathway &amp; wall lighting</li>
//                   <li>Low power consumption</li>
//                 </ul>
//                 <a 
//                   href="https://skyblue-mink-835304.hostingersite.com/flood-lights/" 
//                   className="space-cta"
//                 >
//                   Explore Outdoor Lighting →
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* ================= RESIDENTIAL LIGHTING HERO ================= */}
//       <section className="hlc-res-hero">
//         <div className="hlc-res-hero__inner">
//           <div className="hlc-res-hero__cta">
//             <a 
//               href="https://skyblue-mink-835304.hostingersite.com/shop/" 
//               className="btn-primary"
//             >
//               Explore Products
//             </a>
//             <a 
//               href="https://wa.me/923337244858" 
//               target="_blank" 
//               rel="noopener noreferrer"
//               className="btn-secondary"
//             >
//               WhatsApp Expert
//             </a>
//           </div>
//         </div>
//       </section>

//       <div style={{height:50}}/>

//       <style jsx>{`
//         /* ================= RESIDENTIAL SPACES ================= */
//         .hlc-res-spaces {
//           background: #ffffff;
//           padding: 70px 16px;
//           font-family: system-ui, Segoe UI, Roboto, sans-serif;
//         }

//         .hlc-res-spaces__inner {
//           max-width: 1200px;
//           margin: auto;
//         }

//         /* Head */
//         .hlc-res-spaces__head {
//           text-align: center;
//           max-width: 760px;
//           margin: 0 auto 46px;
//         }

//         .hlc-res-spaces__head h2 {
//           font-size: 30px;
//           font-weight: 800;
//           margin: 0 0 10px;
//           color: #141320;
//         }

//         .hlc-res-spaces__head p {
//           font-size: 15px;
//           color: #555;
//           line-height: 1.6;
//         }

//         /* Grid */
//         .hlc-res-spaces__grid {
//           display: grid;
//           grid-template-columns: repeat(2, 1fr);
//           gap: 30px;
//         }

//         /* Card */
//         .space-card {
//           display: grid;
//           grid-template-columns: 1fr 1fr;
//           border: 1px solid #eee;
//           background: #fafafa;
//           transition: 0.3s;
//         }

//         .space-card:hover {
//           border-color: #9b1f6c;
//           box-shadow: 0 18px 40px rgba(155, 31, 108, 0.18);
//         }

//         /* Image */
//         .space-card img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//         }

//         /* Body */
//         .space-body {
//           padding: 22px;
//           display: flex;
//           flex-direction: column;
//         }

//         .space-body h3 {
//           font-size: 20px;
//           margin: 0 0 6px;
//         }

//         .space-body p {
//           font-size: 14px;
//           color: #555;
//           margin-bottom: 10px;
//         }

//         .space-body ul {
//           padding-left: 18px;
//           margin: 0 0 14px;
//         }

//         .space-body li {
//           font-size: 13px;
//           color: #555;
//           margin-bottom: 4px;
//         }

//         /* CTA */
//         .space-cta {
//           margin-top: auto;
//           font-size: 13px;
//           font-weight: 800;
//           letter-spacing: 0.12em;
//           text-transform: uppercase;
//           color: #9b1f6c;
//           text-decoration: none;
//         }

//         .space-cta:hover {
//           color: #542757;
//         }

//         /* RESPONSIVE */
//         @media (max-width: 900px) {
//           .hlc-res-spaces__grid {
//             grid-template-columns: 1fr;
//           }

//           .space-card {
//             grid-template-columns: 1fr;
//           }

//           .space-card img {
//             height: 220px;
//           }
//         }

//         /* ================= RESIDENTIAL HERO ================= */
//         .hlc-res-hero__inner {
//           display: flex;
//           justify-content: center;
//           align-items: center;
//         }

//         /* CTA */
//         .hlc-res-hero__cta {
//           display: flex;
//           gap: 14px;
//           flex-wrap: wrap;
//           justify-content: center;
//           align-items: center;
//           text-align: center;
//         }

//         /* Buttons */
//         .btn-primary,
//         .btn-secondary {
//           padding: 12px 22px;
//           font-weight: 800;
//           font-size: 14px;
//           text-decoration: none;
//           border-radius: 0;
//           border: 2px solid transparent;
//         }

//         /* Primary */
//         .btn-primary {
//           background: #9b1f6c;
//           color: #fff;
//           border-color: #9b1f6c;
//         }

//         .btn-primary:hover {
//           background: #7f1958;
//           border-color: #7f1958;
//         }

//         /* Secondary */
//         .btn-secondary {
//           background: #fff;
//           color: #9b1f6c;
//           border-color: #9b1f6c;
//         }

//         .btn-secondary:hover {
//           background: #9b1f6c;
//           color: #fff;
//         }

//         /* RESPONSIVE */
//         @media (max-width: 768px) {
//           .hlc-res-hero {
//             padding: 40px 16px 50px;
//           }
//         }
//       `}</style>
//       <HlcFooter/>
//     </>
//   );
// };

// export default ResidentialPage;



import React from 'react';
import Navbar from '../components/Navbar';
import HlcFooter from '../components/HlcFooter';
import { useNavigate } from 'react-router-dom';
import ResidentialImg from '../assets/indoor/hlc-residential-indoor-lighting.webp';
import ResidentialOutdoorImg from '../assets/indoor/hlc-outdoor-lighting.webp';

const ResidentialPage = () => {
  const navigate = useNavigate();

  const handleSubcategoryClick = (subType) => {
    navigate('/product-by-application', {
      state: {
        category: 'Residential Lighting',
        subcategory: subType,
        subcategoryDescription: `Explore the best ${subType} lighting products for your home.`,
      },
    });
  };

  return (
    <>
      <Navbar />
      {/* ================= RESIDENTIAL SPACES – CORE ================= */}
      <section style={{ marginTop: 30 }} className="hlc-res-spaces">
        <div className="hlc-res-spaces__inner">
          {/* Section Head */}
          <header className="hlc-res-spaces__head">
            <h2>Lighting for Every Residential Space</h2>
            <p>
              Thoughtfully designed lighting solutions tailored for different areas of your home —
              combining comfort, efficiency and modern aesthetics.
            </p>
          </header>

          {/* Spaces Grid */}
          <div className="hlc-res-spaces__grid">
            {/* Living Room */}
            <div className="space-card">
              <img 
                decoding="async" 
                src={ResidentialImg}
                alt="Living Room Lighting"
              />
              <div className="space-body">
                <h3>Living Rooms</h3>
                <p>Warm, ambient lighting for relaxation, gatherings and everyday comfort.</p>
                <ul>
                  <li>• Soft & glare-free illumination</li>
                  <li>• Decorative bulbs & ceiling lights</li>
                  <li>• Energy-efficient LEDs</li>
                </ul>
                <button 
                  className="space-cta"
                  onClick={() => handleSubcategoryClick('Living Rooms')}
                >
                  Explore Living Room Lighting →
                </button>
              </div>
            </div>

            {/* Bedrooms */}
            <div className="space-card">
              <img 
                decoding="async" 
                src={ResidentialImg}
                alt="Bedroom Lighting"
              />
              <div className="space-body">
                <h3>Bedrooms</h3>
                <p>Comfortable and soothing lighting designed for rest and personal spaces.</p>
                <ul>
                  <li>• Low-glare & warm light tones</li>
                  <li>• Bedside & accent lighting</li>
                  <li>• Long-life LED solutions</li>
                </ul>
                <button 
                  className="space-cta"
                  onClick={() => handleSubcategoryClick('Bedrooms')}
                >
                  Explore Bedroom Lighting →
                </button>
              </div>
            </div>

            {/* Kitchens */}
            <div className="space-card">
              <img 
                decoding="async" 
                src={ResidentialImg}
                alt="Kitchen Lighting"
              />
              <div className="space-body">
                <h3>Kitchens</h3>
                <p>Bright and focused lighting to support cooking, cleaning and productivity.</p>
                <ul>
                  <li>• Uniform task lighting</li>
                  <li>• Under-cabinet LEDs</li>
                  <li>• High efficiency & durability</li>
                </ul>
                <button 
                  className="space-cta"
                  onClick={() => handleSubcategoryClick('Kitchens')}
                >
                  Explore Kitchen Lighting →
                </button>
              </div>
            </div>

            {/* Outdoor / Balconies */}
            <div className="space-card">
              <img 
                decoding="async" 
                src={ResidentialOutdoorImg}
                alt="Outdoor Home Lighting"
              />
              <div className="space-body">
                <h3>Outdoor & Balconies</h3>
                <p>Weather-resistant lighting to enhance safety and outdoor aesthetics.</p>
                <ul>
                  <li>• IP-rated outdoor lights</li>
                  <li>• Pathway & wall lighting</li>
                  <li>• Low power consumption</li>
                </ul>
                <button 
                  className="space-cta"
                  onClick={() => handleSubcategoryClick('Outdoor & Balconies')}
                >
                  Explore Outdoor Lighting →
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= RESIDENTIAL LIGHTING HERO ================= */}
      <section className="hlc-res-hero">
        <div className="hlc-res-hero__inner">
          <div className="hlc-res-hero__cta">
            <a 
            onClick={()=>navigate('/shop')}
              className="btn-primary"
            >
              Explore Products
            </a>
            <a 
              href="https://wa.me/923337244858" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn-secondary"
            >
              WhatsApp Expert
            </a>
          </div>
        </div>
      </section>

      <div style={{ height: 50 }} />

      <style jsx>{`
        .hlc-res-spaces { background: #ffffff; padding: 70px 16px; font-family: system-ui, Segoe UI, Roboto, sans-serif; }
        .hlc-res-spaces__inner { max-width: 1200px; margin: auto; }
        .hlc-res-spaces__head { text-align: center; max-width: 760px; margin: 0 auto 46px; }
        .hlc-res-spaces__head h2 { font-size: 30px; font-weight: 800; margin: 0 0 10px; color: #141320; }
        .hlc-res-spaces__head p { font-size: 15px; color: #555; line-height: 1.6; }
        .hlc-res-spaces__grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 30px; }
        .space-card { display: grid; grid-template-columns: 1fr 1fr; border: 1px solid #eee; background: #fafafa; transition: 0.3s; }
        .space-card:hover { border-color: #9b1f6c; box-shadow: 0 18px 40px rgba(155, 31, 108, 0.18); }
        .space-card img { width: 100%; height: 100%; object-fit: cover; }
        .space-body { padding: 22px; display: flex; flex-direction: column; }
        .space-body h3 { font-size: 20px; margin: 0 0 6px; }
        .space-body p { font-size: 14px; color: #555; margin-bottom: 10px; }
        .space-body ul { padding-left: 18px; margin: 0 0 14px; }
        .space-body li { font-size: 13px; color: #555; margin-bottom: 4px; }
        .space-cta { margin-top: auto; font-size: 13px; font-weight: 800; letter-spacing: 0.12em; text-transform: uppercase; color: #9b1f6c; background: none; border: none; text-align: left; cursor: pointer; padding: 0; }
        .space-cta:hover { color: #542757; }
        @media (max-width: 900px) { .hlc-res-spaces__grid { grid-template-columns: 1fr; } .space-card { grid-template-columns: 1fr; } .space-card img { height: 220px; } }
        .hlc-res-hero__inner { display: flex; justify-content: center; align-items: center; }
        .hlc-res-hero__cta { display: flex; gap: 14px; flex-wrap: wrap; justify-content: center; align-items: center; text-align: center; }
        .btn-primary, .btn-secondary { padding: 12px 22px; font-weight: 800; font-size: 14px; text-decoration: none; border-radius: 0; border: 2px solid transparent; }
        .btn-primary { background: #9b1f6c; color: #fff; border-color: #9b1f6c; }
        .btn-primary:hover { background: #7f1958; border-color: #7f1958; }
        .btn-secondary { background: #fff; color: #9b1f6c; border-color: #9b1f6c; }
        .btn-secondary:hover { background: #9b1f6c; color: #fff; }
        @media (max-width: 768px) { .hlc-res-hero { padding: 40px 16px 50px; } }
      `}</style>
      <HlcFooter />
    </>
  );
};

export default ResidentialPage;
